function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.profitable_growth_st0{fill:none;}\n\t.profitable_growth_st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.profitable_growth_st2{fill:#FFFFFF;}\n\t.profitable_growth_st3{mask:url(#mask-2_1_);}\n\t.profitable_growth_st4{fill-rule:evenodd;clip-rule:evenodd;fill:#7500C0;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "rect-1_1_",
  className: "profitable_growth_st0",
  width: 60,
  height: 60
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 60,
  height: 60,
  id: "mask-2_1_"
}, /*#__PURE__*/React.createElement("rect", {
  className: "profitable_growth_st1",
  width: 60,
  height: 60
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "rect-1_2_",
  className: "profitable_growth_st2",
  width: 60,
  height: 60
}))), /*#__PURE__*/React.createElement("g", {
  className: "profitable_growth_st3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "profitable_growth_st0",
  width: 60,
  height: 60
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "profitable_growth_st4",
  d: "M43.6,27.3h-3.1c-0.3-1-0.7-1.9-1.2-2.8l2.2-2.2l-3.9-3.9l-2.2,2.2c-0.9-0.5-1.8-0.9-2.8-1.2v-3.1h-5.5v3.1 c-1,0.3-1.9,0.7-2.8,1.2l-2.2-2.2l-3.9,3.9l2.2,2.2c-0.5,0.9-0.9,1.8-1.2,2.8h-3.1v5.5h3.1c0.3,1,0.7,1.9,1.2,2.8l-2.2,2.2 l3.9,3.9l2.2-2.2c0.9,0.5,1.8,0.9,2.8,1.2l0-5.8c-1.6-0.9-2.7-2.7-2.7-4.7c0-3,2.4-5.5,5.5-5.5s5.5,2.4,5.5,5.5 c0,1-0.3,1.9-0.7,2.7h8.9C43.6,32.7,43.6,27.3,43.6,27.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "profitable_growth_st4",
  d: "M35.5,8.2l-8.2-5.5v2.9C15,7,5.5,17.4,5.5,30h5.5c0-9.6,7.1-17.6,16.4-18.9v2.5C27.3,13.6,35.5,8.2,35.5,8.2 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "profitable_growth_st4",
  d: "M54.5,30h-5.5c0,9.6-7.1,17.6-16.4,18.9v-2.5l-8.2,5.5l8.2,5.5v-2.9C45,53,54.5,42.6,54.5,30z"
}), /*#__PURE__*/React.createElement("path", {
  className: "profitable_growth_st4",
  d: "M27.3,34.7c0.8,0.5,1.7,0.7,2.7,0.7s1.9-0.3,2.7-0.7v8.9h-5.5C27.3,43.6,27.3,34.7,27.3,34.7z"
}))));

var SvgProfitableGrowth = function SvgProfitableGrowth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfitableGrowth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProfitableGrowth.b24eb2bd.svg";
export { ForwardRef as ReactComponent };